(function ($) {
    'use strict';
    const confirmPopoverButton = "FD_CONFIRM_POPOVER_BUTTON";
    $.widget("fd.control_confirmationpopover", {
        options: {
            confirmcallback: null,
            confirmclass: 'btn-primary',
            confirmlabel: 'Yes',
            cancelcallback: null,
            cancelclass: 'btn-link',
            cancellabel: 'Cancel',
            message: 'Are you sure?',
            container: 'body',
            parentid: null,
            passthrough: null,
            sanitize: false // set to true if this popover displays any user-generated information
        },
        _create: function () {
            if (!this.options.parentid) {
                this.options.parentid = this.element.closest('[data-fd-parentid]').data('fd-parentid');
            }
            if (this.element.attr('tabindex') === undefined) { // Dismiss on next click doesn't work without tabindex value
                this.element.attr('tabindex', 0);
            }

            this._createPopover();
        },
        _createPopover: function () {
            if (this.element.popover) {
                this.element.popover('dispose');
            }
            const popoverHTML = [],
                options = {
                    container: this.options.container,
                    title: this.options.message,
                    html: true,
                    sanitize: this.options.sanitize,
                    trigger: 'manual'
                };

            //  confirm button
            popoverHTML.push("<button id='" + confirmPopoverButton + "' type='button' data-fd-control='button' data-fd-parentid='" + this.options.parentid + "' data-fd-passthrough='" + this.options.passthrough + "' data-fd-callback='" + this.options.confirmcallback_RAW
                + "' class='btn " + this.options.confirmclass + " btn-sm mr-1'><i class='fas fa-sm fa-check mr-1'></i>" + this.options.confirmlabel + "</button>");

            //  cancel button
            if (this.options.cancelcallback) {
                popoverHTML.push("<button type='button' data-fd-control='button' data-fd-parentid='" + this.options.parentid + "'  data-fd-passthrough='" + this.options.passthrough + "' data-fd-callback='" + this.options.cancelcallback_RAW
                    + "' class='btn " + this.options.cancelclass + " btn-sm'><i class='fas fa-times mr-1'></i>" + this.options.cancellabel + "</button>");
            } else {
                popoverHTML.push("<button type='button' class='btn " + this.options.cancelclass
                    + " btn-sm'><i class='fas fa-times mr-1'></i>" + this.options.cancellabel + "</button>");
            }

            options.content = popoverHTML.join('');
            this.element.popover(options);
            this._setEvents();
        },
        _popoverEventsAreSet: false,
        _setEvents: function () {
            var that = this;
            this.element.off('click.fdcontrol shown.bs.popover hidden.bs.popover').on('click.fdcontrol', function (event, doAjaxPost) {
                if (doAjaxPost) {
                    return;
                }

                if ($("#" + confirmPopoverButton).length) {
                    return false; // only allow one popover open at a time
                }

                if (that.options.parentid != that.element.closest('[data-fd-parentid]').data('fd-parentid')) {
                    that.options.parentid = that.element.closest('[data-fd-parentid]').data('fd-parentid');
                    that._createPopover();
                }

                that.element.popover('show');
                that.element.addClass('fd-opacity-50');
                return false;
            }).on('shown.bs.popover', function () {
                $(window).click(function () {
                    that.element.popover('hide');
                    $(window).off('click');
                });

                $('.popover').enableControls().off('click').on('click', function (event) {
                    if (!$(event.target).is('button')) {
                        event.stopPropagation();
                    }

                    // Trigger a new click on the original link to automaticaly run data-ajax code.
                    if (that.element.is('[data-ajax=true]') && $(event.target).closest('button').is('#FD_CONFIRM_POPOVER_BUTTON')) {
                        that.element.trigger('click', true);
                    }
                });
            }).on('hidden.bs.popover', function () {
                that.element.removeClass('fd-opacity-50');
            });
        },
        _setOption: function (key, value) {
            this.options[key] = value;
            if (key === 'parentid' || key === 'passthrough') {
                this._createPopover();
            }
        }
    });
}(jQuery));